import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

const OPTIONAL_EMAIL = /^$|^[^@\s]+@[^@\s]+\.[^@\s]+$/;
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AdminUpdateUserRequest, UserProfileDto } from '../../models/user-profile.model';
import { UserProfileService } from '../../services/user-profile.service';

export interface UserAdminDialogData {
  user: UserProfileDto;
}

@Component({
  selector: 'app-user-admin-dialog',
  templateUrl: './user-admin-dialog.component.html',
  styleUrls: ['./user-admin-dialog.component.css']
})
export class UserAdminDialogComponent implements OnInit {

  form: FormGroup;
  saving = false;
  msg = '';

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<UserAdminDialogComponent, boolean>,
    @Inject(MAT_DIALOG_DATA) public data: UserAdminDialogData,
    private userProfileService: UserProfileService
  ) { }

  ngOnInit(): void {
    const u = this.data.user;
    this.form = this.fb.group({
      firstName: [u.firstName || '', [Validators.required]],
      lastName: [u.lastName || '', [Validators.required]],
      email: [u.email || '', [Validators.pattern(OPTIONAL_EMAIL)]],
      phoneNumber: [u.phoneNumber || u.mobileNumber || ''],
      newPassword: ['', [Validators.minLength(6)]]
    });
  }

  cancel(): void {
    this.dialogRef.close(false);
  }

  submit(): void {
    this.msg = '';
    if (!this.data.user.id || this.form.invalid) {
      return;
    }
    const v = this.form.value;
    const body: AdminUpdateUserRequest = {
      firstName: v.firstName.trim(),
      lastName: v.lastName.trim(),
      email: (v.email || '').trim() || undefined,
      phoneNumber: (v.phoneNumber || '').trim() || undefined
    };
    const np = (v.newPassword || '').trim();
    if (np) {
      body.newPassword = np;
    }

    this.saving = true;
    this.userProfileService.updateUser(this.data.user.id as number, body).subscribe(
      () => {
        this.saving = false;
        this.dialogRef.close(true);
      },
      () => {
        this.saving = false;
        this.msg = 'Update failed. Check permissions or API.';
      }
    );
  }
}
